import ReactComponent from '../app/ReactComponent'
import {Flex} from 'antd'
import {$t} from '../app'

export default class WhoWeArePage extends ReactComponent {

  componentDidMount() {
    this.$app.$theme('dark')
  }

  render() {
    return (
      <section className="fullwidth">
        <Flex align="center" justify="center" style={{height: '100%', minHeight: '90vh'}}>
          <div className="container ta-center">
            <h2><$t _="coming_soon" /></h2>
          </div>
        </Flex>
      </section>
    )
  }
}